import React from "react";

const ButtonClick = ({ config }) => {
  return (
    <div className={config.classContainer}>
      <div className="div-input-button">
        <input
          type='button'
          className={config.classInput}
          value={config.label}
          onClick={config.onClick}
        />
      </div>
    </div>
  )
}

export default ButtonClick;
